import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
List:{
    
    maxHeight:'auto',
    [theme.breakpoints.up("sm")]: {
  
      
        overflow: 'auto',
    
}
}


}));

export default useStyles;
